import { forwardRef, type Ref, type SVGProps } from "react";

function SvgArrowDown(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.333 9.333 8 13.667m0 0L3.667 9.333M8 13.667V2.333"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
